document.addEventListener("DOMContentLoaded", () => {
  const format = (seconds) => {
    if (!isFinite(seconds)) return "--:--";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  };

  document.querySelectorAll("[data-episode-player]").forEach((player) => {
    const audio = new Audio();
    audio.preload = "metadata";
    audio.src = player.dataset.src;

    const playBtn = player.querySelector("[data-play]");
    const progress = player.querySelector("[data-progress]");
    const time = player.querySelector("[data-time]");
    const speedBtn = player.querySelector("[data-speed]");
    const muteBtn = player.querySelector("[data-mute]");
    const shareBtn = player.querySelector("[data-share]");
    const speeds = [1, 1.25, 1.5, 2, 0.75];
    let speedIndex = 0;
    let seeking = false;

    const paint = () => {
      const duration = audio.duration;
      const pct = isFinite(duration) && duration > 0 ? (audio.currentTime / duration) * 100 : 0;
      if (!seeking) progress.value = pct;
      progress.style.setProperty("--p", pct + "%");
      time.textContent = format(audio.currentTime) + " | " + format(duration);
    };

    playBtn.addEventListener("click", () => {
      if (audio.paused) {
        audio.play().catch(() => {});
      } else {
        audio.pause();
      }
    });
    audio.addEventListener("play", () => {
      player.classList.add("is-playing");
      playBtn.setAttribute("aria-label", "Pause");
    });
    audio.addEventListener("pause", () => {
      player.classList.remove("is-playing");
      playBtn.setAttribute("aria-label", "Play");
    });
    audio.addEventListener("loadedmetadata", paint);
    audio.addEventListener("timeupdate", paint);
    audio.addEventListener("ended", () => player.classList.remove("is-playing"));

    progress.addEventListener("input", () => {
      seeking = true;
      progress.style.setProperty("--p", progress.value + "%");
      if (isFinite(audio.duration)) {
        time.textContent = format((progress.value / 100) * audio.duration) + " | " + format(audio.duration);
      }
    });
    progress.addEventListener("change", () => {
      if (isFinite(audio.duration)) audio.currentTime = (progress.value / 100) * audio.duration;
      seeking = false;
    });

    player.querySelectorAll("[data-skip]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const next = audio.currentTime + Number(btn.dataset.skip);
        audio.currentTime = Math.max(0, isFinite(audio.duration) ? Math.min(audio.duration, next) : next);
      });
    });

    speedBtn.addEventListener("click", () => {
      speedIndex = (speedIndex + 1) % speeds.length;
      audio.playbackRate = speeds[speedIndex];
      speedBtn.textContent = speeds[speedIndex] + "x";
    });

    muteBtn.addEventListener("click", () => {
      audio.muted = !audio.muted;
      muteBtn.classList.toggle("is-muted", audio.muted);
      muteBtn.setAttribute("aria-label", audio.muted ? "Unmute" : "Mute");
    });

    shareBtn.addEventListener("click", async () => {
      const data = { title: player.dataset.shareTitle || document.title, url: window.location.href };
      if (navigator.share) {
        try { await navigator.share(data); } catch (e) { /* cancelled */ }
        return;
      }
      try {
        await navigator.clipboard.writeText(data.url);
        const original = shareBtn.textContent;
        shareBtn.textContent = "Link copied";
        setTimeout(() => { shareBtn.textContent = original; }, 2000);
      } catch (e) { /* clipboard unavailable */ }
    });
  });

  // Transcript popup
  const dialog = document.querySelector("[data-transcript-dialog]");
  if (dialog) {
    document.querySelectorAll("[data-transcript-open]").forEach((btn) => {
      btn.addEventListener("click", () => dialog.showModal());
    });
    dialog.querySelectorAll("[data-transcript-close]").forEach((btn) => {
      btn.addEventListener("click", () => dialog.close());
    });
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
  }
});
